import styled from 'styled-components';
import { clearButtonStyles, CheckBox, CheckBoxWrapper } from '../../base';

export const Line = styled.div`
	display: flex;
	align-items: center;
`;

export const CheckWrapper = styled(CheckBoxWrapper)`

`;

export const Check = styled(CheckBox)`
	margin-right: 1.8rem;
`;

export const Text = styled.div`
	font-size: 1.3rem;
	font-weight: 600;
`;

export const SaveRow = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 0.5rem;

	button {
		font-size: 1.6rem;
		color: ${({ theme }) => theme.colors.primary};
		font-weight: 700;
		cursor: pointer;
	}
`;

export const SaveButton = styled.button`
	${clearButtonStyles};
`;
